import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { Subtype } from "~/models/Subtype";

const paths = {
	index: "/subtypes",
	show: "/subtypes/:id"
};

type TIndex = () => SwrReturnType<Subtype[]>;
type TShow = (id: number | null) => SwrReturnType<Subtype>;
type ReturnType = {
	useIndex: TIndex;
	useShow: TShow;
};

export const useSubtypes = (): ReturnType => {
	const useIndex: TIndex = () => {
		const { data, mutate, error } = useSWR<Subtype[]>(paths.index);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate: mutate ?? null
		};
	};
	const useShow: TShow = (id: number | null) => {
		const { data, mutate, error } = useSWR<Subtype>(
			id === null ? null : paths.show.replace(":id", id.toString())
		);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate: mutate ?? null
		};
	};
	return { useIndex, useShow };
};
